import { useTypedQuery } from "hooks";
import { QuestionsDashboardQueryKeys } from "modules/QuestionsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useQuestionElementsQuery = () =>
  useTypedQuery({
    queryKey: QuestionsDashboardQueryKeys.questionElements,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.get(endpoint, baseUrl)).data.question_elements ?? []
  });
